import { ReactElement } from 'react';

import { AlertErrorIcon, AlertPrimaryIcon, AlertSuccessIcon, AlertWarningIcon } from '@braskai/icons';
import { ModalHeader } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { ModalHeaderProps } from '../../lib/types';
import { SContainer } from './styled';

const { Container, Subtitle, Title } = ModalHeader;

const ICONS = {
  error: <AlertErrorIcon height={48} width={48} />,
  info: <AlertPrimaryIcon height={48} width={48} />,
  success: <AlertSuccessIcon height={48} width={48} />,
  warning: <AlertWarningIcon height={48} width={48} />,
} as const;

type ModalHeaderDefaultProps = {
  icon?: ReactElement;
  iconType?: keyof typeof ICONS;
} & ModalHeaderProps;

export const ModalHeaderWithIcon = ({
  title,
  icon,
  iconType,
  maxLinesSubtitle,
  maxLinesTitle,
  subtitle,
  ...props
}: ModalHeaderDefaultProps) => (
  <Container {...props}>
    <SContainer gap={12}>
      {iconType ? ICONS[iconType] : icon}
      <Stack gap={4}>
        <Title maxLines={maxLinesTitle}>{title}</Title>
        {subtitle && <Subtitle maxLines={maxLinesSubtitle}>{subtitle}</Subtitle>}
      </Stack>
    </SContainer>
  </Container>
);
